module.exports = __webpack_public_path__ + "img/Aperature Priority-High.b2da0227.jpg";